import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  id: PropTypes.string,
};

const PostcardIcon = ({
  color = '#0e84fe',
  width = 20,
  id = 'postcard-icon',
  ...props
}) => (
  <svg
    width={width}
    viewBox="0 0 35 27"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M30.18-.244c1.741 0 3.153 1.426 3.153 3.186v19.116c0 1.76-1.412 3.186-3.154 3.186H2.842c-1.742 0-3.154-1.426-3.154-3.186V2.942c0-1.76 1.412-3.186 3.154-3.186H30.18zM11.603 19.58h-8.41v2.831h8.41V19.58zm2.804-5.664H3.193v2.832h11.215v-2.832zM27.13 3.676c-1.652 0-2.208 1.376-2.208 1.376s-.556-1.375-2.208-1.375c-1.65 0-2.645 1.477-2.645 2.694 0 1.726 3.475 4.217 4.544 4.943l.166.112.09.06.047.03.006.004s4.853-3.108 4.853-5.149c0-1.217-.994-2.694-2.645-2.694z"
        id={`${id}-a`}
      />
    </defs>
    <g transform="translate(1.306 1)" fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        fill={color}
        mask={`url(#${id}-b)`}
        d="M-4.39-5.342h43.84v34.665H-4.39z"
      />
    </g>
  </svg>
);

PostcardIcon.propTypes = propTypes;

export default PostcardIcon;
